// @flow
import * as React from 'react';
import styled from 'styled-components';
import colors from "../../../assets/css/colors";
import { below, above } from '../../../assets/css/media';
import {
	TableGrid,
	TableFlexRow,
	TableFlexBody
} from "../../../components";

import JoinLeagueRow from './JoinLeagueRow';

type Props = {
	leagues_list: Array<Object>,
	handleLeagueJoinPopup: Function,
	handleLeagueSettingsPopup: Function,
	join: Function
}

const JoinLeagueTableFlexHeading = styled(TableFlexRow)`
	font-size: 10px;
	background-color: ${colors.nrlDarkGreen};
	font-weight: bold;
	line-height: 1;
	text-align: center;
	color: #fff;
	div:first-child {
		font-size: 14px;
		text-align: left;
		${below.desktop`
			font-size: 12px;
		`}
	}

	${below.desktop`
		grid-template-columns: auto 80px 80px;
	`}
`;

const NameTh = styled.div`
	flex-basis: 50%;

	${below.desktop`
		flex-basis: 70%;
	`}
`;

const ColumnItem = styled.div`
	flex-basis: 10%;
`;

const Title = styled.div`
	padding-left: 19px;
	display: none;
	${({ mobile }) => mobile && below.tablet`
		display: block;
	`}
	${({ desktop }) => desktop && above.tablet`
		display: block;
	`}
`;

export const JoinLeagueList = ({
	leagues_list, handleLeagueJoinPopup, handleLeagueSettingsPopup, join
}: Props) => (
	<TableGrid>
		<JoinLeagueTableFlexHeading height="50px">
			<NameTh role="columnheader">
				<Title desktop>
					LEAGUE NAME / COMMISSIONER NAME
				</Title>
				<Title mobile>
					LEAGUE / COMMISSIONER
				</Title>
			</NameTh>
			<ColumnItem role="columnheader" className="hidden-mobile">
				LEAGUE SIZE
			</ColumnItem>
			<ColumnItem role="columnheader" className="hidden-mobile">
				START ROUND
			</ColumnItem>
			<ColumnItem role="columnheader">
				SETTINGS
			</ColumnItem>
			<ColumnItem role="columnheader">
				JOIN LEAGUE
			</ColumnItem>
		</JoinLeagueTableFlexHeading>
		<TableFlexBody>
			{leagues_list.map(league => (
				<JoinLeagueRow key={league.id}
					league={league}
					join={join}
					handleLeagueSettingsPopup={handleLeagueSettingsPopup}
					handleLeagueJoinPopup={handleLeagueJoinPopup}
				/>
			))}
		</TableFlexBody>
	</TableGrid>

);

export default JoinLeagueList;


// WEBPACK FOOTER //
// ./src/pages/leagues/leaguesJoin/JoinLeagueList.js